module.exports = __webpack_public_path__ + "img/male_A_01.535a37f5.png";